const MENU_PERMISSIONS = {
  // Config screens (keep :read/:write split)
  ADMIN: 'egov:config.empresas:write',
  EMPREGADORES: 'egov:config.empresas:read',
  // Consultation screens (single permission = full access)
  ANALISTA_AGNES: 'egov:folha.rubricas',
  SAUDE_SEGURANCA_AGENTES_NOCIVOS_APOSENTADORIA_ESPECIAL: 'egov:saude.agentes-nocivos',
  AFASTADOS_E_INATIVOS: 'egov:trabalhador.afastamento',
  CBO: 'egov:trabalhador.cbo',
  HORARIOS_E_JORNADA: 'egov:trabalhador.horarios',
  INDICADORES: 'egov:folha.indicadores',
  FOLHA_DE_PAGAMENTO: 'egov:folha.rubricas',
  DCTF: 'egov:encargos.dctf',
  MENSAGENS_ECAC: 'egov:encargos.mensagens-ecac',
  ENCARGOS_OPORTUNIDADES: 'egov:encargos.oportunidades',
  ENCARGOS_OPORTUNIDADES_EDITAR: 'egov:encargos.oportunidades',
  EGOV: 'egov:egov.cessao',
  CESSAO: 'egov:egov.cessao',
  CERTIDAO_FEDERAL: 'egov:certidoes.cnd',
  CRF: 'egov:certidoes.crf',
  CRF_EDITAR: 'egov:certidoes.crf',
  // Reusa a permissão do CRF — sem permissão própria pro CNDT, cadastrar uma nova
  // depende do tax-tech (EgovPermissionRegistrar), fora de escopo por ora.
  CNDT: 'egov:certidoes.crf',
  CENTRAL_REPROCESSAMENTO: 'egov:reprocessamento',
  // Config — granular (CON-4960)
  CONFIG_USUARIOS_READ: 'egov:config.usuarios:read',
  CONFIG_USUARIOS_WRITE: 'egov:config.usuarios:write',
  CONFIG_USUARIOS_PERMISSOES_WRITE: 'egov:config.usuarios-permissoes:write',
  CONFIG_USUARIOS_SEGURANCA_WRITE: 'egov:config.usuarios-seguranca:write',
  CONFIG_USUARIOS_ESTAB_READ: 'egov:config.usuarios-estabelecimentos:read',
  CONFIG_EMPRESAS_READ: 'egov:config.empresas:read',
  CONFIG_ESTABELECIMENTOS_READ: 'egov:config.estabelecimentos:read',
  CONFIG_GRUPOS_READ: 'egov:config.grupos:read',
  CONFIG_ESOCIAL_IMPORTACAO_READ: 'egov:config.esocial-importacao:read',
  CONFIG_ESOCIAL_IMPORTACAO_WRITE: 'egov:config.esocial-importacao:write',
  CONFIG_TAB_NATUREZA_READ: 'egov:config.tabelas-natureza-rubrica:read',
  CONFIG_TAB_TIPO_READ: 'egov:config.tabelas-tipo-rubrica:read',
  CONFIG_TAB_CBO_READ: 'egov:config.tabelas-cbo:read',
  CONFIG_TAB_INCIDENCIAS_READ: 'egov:config.tabelas-incidencias:read',
  CONFIG_TAB_INCIDENCIAS_WRITE: 'egov:config.tabelas-incidencias:write',
  CONFIG_PARAMETROS_ANALISE_READ: 'egov:config.parametros-analise:read',
  CONFIG_ECAC_INTEGRACAO_READ: 'egov:config.ecac-integracao:read',
  CONFIG_ECAC_MENSAGENS_WRITE: 'egov:config.ecac-mensagens:write',
  CONFIG_AUDITORIA_READ: 'egov:config.auditoria:read',
  CONFIG_DOCUMENTOS_READ: 'egov:config.documentos:read',
  CONFIG_PERFIS_READ: 'egov:config.perfis:read',
  CONFIG_PERFIS_WRITE: 'egov:config.perfis:write',
  CONFIG_TABELAS_HUB: [
    'egov:config.tabelas-natureza-rubrica:read',
    'egov:config.tabelas-tipo-rubrica:read',
    'egov:config.tabelas-cbo:read',
    'egov:config.tabelas-incidencias:read',
  ],
  REPROCESSAMENTO: 'egov:reprocessamento',
};

export default MENU_PERMISSIONS;
